const color = {
  primaryColor: "#FEC31A",
  secondaryColor:  "#1858b9",
  backgroundColor: "#f6f6fa",

  //button
  blackButtonColor: "#495057",
  blueButtonColor: "#1858b9",
  amountButtonBackgroundColor: "#e8e8e8",
  disabledButtonColor: "#aaaaaa",

  //text
  primaryTextColor: "#495057",
  primaryDisabledColor:"#B1B1B1",
  secondaryTextColor: "#74788d",
  placeHolderTextColor: "#b6b9bc",

  debitTextColor: "#f26a6b",
  creditTextColor: "#36c58f",

  textInputColor: "#ced4da",

  //inbox
  inboxBackgroundColor: "#eff2f7",
  inboxCloseContainerColor: "#f46a6a",

  //footer
  footerBackgroundColor: "#e4e4ea",

  //divider
  dividerColor: "#f1f2f8",

  //others
  masterAccountContainerColor: "#ecf2fc",
  referAndEarnContainerColor: "#253e64",
  referralLinkContainerColor: "#f4f4f4",
  emailIconBackgroundColor: "#9cc7d1",
  opacityBorderColor: "rgba(72, 79, 86, 0.5)",

  //border color
  borderColor: "#ced4da",
  errorBorderColor: "red",

  white: "#fff",
  black: "#000",
};

export default color;
